export enum ESlopeChartSurface {
  ASPHALT = 'asphalt',
  CONCRETE = 'concrete',
  DIRT = 'dirt',
  GRASS = 'grass',
  GRAVEL = 'gravel',
  PAVED = 'paved',
  SAND = 'sand',
}
